export default "/images/328cf970267e61913704b5ee3472c298.avif";